<template>
    <div class="phoneSettin">
         <!-- 头部 -->
        <div class="header">
            <div class="header-left" @click="back">
              <span class="iconfont iconzuojiantou"></span>
            </div>
            <div class="header-center">
                <P>绑定手机</P>
            </div>
            <div></div>
        </div>
        <!--  -->
        <div class="phone">
            <van-cell-group>
        <van-field
            v-model="phone"
            label="手机号"
            placeholder="请输入手机号"
            error-message=""
            type="number"
        />
        <van-field
            v-model="sms"
            center
            clearable
            label="短信验证码"
            placeholder="请输入短信验证码"
            type="number"
        >
    <van-button slot="button" size="small" type="primary" v-if="countdown > 0">{{countdown}}S</van-button>
    <van-button slot="button" size="small" type="primary" @click="getCode" v-else>发送验证码</van-button>
  </van-field>
        </van-cell-group>
        </div>
        <div class="button" @click="changePhone">
          绑定
        </div>
        
    </div>

</template>

<script>
import { Toast } from 'vant';
import { setInterval, clearInterval } from 'timers';

export default {
    data () {
        return {
            timer: null,
            phone:'',
            sms:'',
            countdown: 0
        }
    },
    computed: {
    rightPhone () {
      return /^1\d{10}$/.test(this.phone)
    }
  },
  methods: {
       back () {
     this.$router.back()
   },
   getCode () {

       if (this.timer) {
             clearInterval(this.timer)
             this.timer = null
       }

       if (this.rightPhone) {

            this.$axios.post('/api/DjCommon/SendCode',{
                Phone: this.phone
            }).then(res => {  // 验证码发送成功
                Toast(res.data.message);

                this.countdown = 60
                this.timer = setInterval(() => {
                        this.countdown--
                               
                },1000)
            })
         
       }else{
           Toast('请输入正确的手机号码！')
       }

      
   },
   changePhone () {
       if (!this.rightPhone) {
          Toast('请输入正确的手机号码！')
       }else if (this.sms == '') {
           Toast('请输入验证码！');
       }else{
           this.$axios.post('/api/DjCommon/BindPhone',{
           Phone: this.phone,
           Code: this.sms
            }).then(res => {
                if (res.data.type == 1 ) {
                  Toast("绑定成功");
                  const Token = res.data.Token
                  localStorage.setItem('kjToken', Token)
                  this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('kjToken')
                  this.$axios.get('/api/DjUser/GetLoginInfo').then(res => {
                    if(res.data.type == 1){
                      this.$store.dispatch('getUser', res.data)
                    }
                  })
                  this.$router.back()
                }else{
                  Toast(res.data.message);
                }
                
               
            })
       }

   }
  },
  watch: {
    countdown (nValue) {
       
        if (nValue == 0) {
                clearInterval(this.timer)
                this.timer =  null
             }
       
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.phoneSettin
  background: rgb(240, 240, 240)
  height: 100vh
  .header
   position: fixed
   z-index: 90
   left: 0
   right: 0
   top: 0
   display: flex
   justify-content: space-between
   width: 100%
   height: 44px
   align-items: center
   background-color: white
   font-weight: bold
   .header-left
     padding-left: 8px
     height: 100%
     width: 40px
     display: flex
     align-items: center
   .header-right
     padding-right: 8px
     width: 40px
   .header-center
     font-size: 20px
     width: 120px
  .phone
   padding-top: 44px
   padding-bottom: 26px
  .button
   width: 90%
   margin: auto
   border-radius: 26px
   background: #009933
   height: 36px
   line-height: 36px
   text-align: center
   color: white
</style>



// WEBPACK FOOTER //
// src/pages/Profile/PhoneSettin.vue